import logo from 'assets/Vector.svg';
import { Link } from 'react-router-dom';

export const Logo = () => {
  return (
    <Link className="flex items-center" to="/">
      <img className="h-12 w-auto" src={logo} alt="Workflow" />
    </Link>
  );
};
